var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"accordion-trigger",class:{ open: _setup.props.isOpen },on:{"click":_vm.toggle}},[_c('span',[_vm._t("default")],2),_c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M6 9l6 6 6-6"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }